module.exports = __webpack_public_path__ + "static/img/NISSIN.5425fb44.png";